import React from "react";
import { NeoButton, NeoInput } from "../../../../../components/Common";
import { MUSCLE_GROUPS, STRENGTH_EQUIPMENT, STRENGTH_EXERCISE_METHODS } from "../../domain/strength/constants";
import { getStrengthExerciseById } from "../../domain/strength/exerciseLibrary";

export const StrengthExerciseRow = ({ baseName, setIndex, set, handleChange, onRemove, onDuplicate, onReplaceExercise, onSaveToLibrary }) => {
    const alternatives = (set.alternatives || [])
        .map(id => getStrengthExerciseById(id))
        .filter(Boolean)
        .map(exercise => ({ id: exercise.id, name: exercise.name }));

    return (
        <div className="bg-light rounded-0 p-3 mb-3 border hover-shadow transition-all strength-exercise-row">

            {/* Linha Principal (Exercício, Séries, Reps, Carga, Descanso) */}
            <div className="row align-items-center g-2">
                <div className="col-lg-4 col-md-6 col-12">
                    <label className="strength-label-sub fw-bold text-uppercase">Exercício</label>
                    <NeoInput
                        type="text"
                        name={`${baseName}.${setIndex}.exercise`}
                        value={set.exercise || ""}
                        onChange={handleChange}
                        size="sm"
                        placeholder="Ex: Supino reto"
                    />
                </div>
                <div className="col-lg-1 col-md-2 col-4">
                    <label className="strength-label-sub fw-bold text-uppercase text-center d-block">Séries</label>
                    <NeoInput
                        type="text"
                        name={`${baseName}.${setIndex}.sets`}
                        value={set.sets || ""}
                        onChange={handleChange}
                        size="sm"
                        placeholder="3"
                    />
                </div>
                <div className="col-lg-auto col-auto d-none d-lg-block px-0 text-center">
                    <span className="font-weight-bold text-muted fw-bold font-size-12 pt-3 d-inline-block">x</span>
                </div>
                <div className="col-lg-2 col-md-2 col-4">
                    <label className="strength-label-sub fw-bold text-uppercase text-center d-block">Repetições</label>
                    <NeoInput
                        type="text"
                        name={`${baseName}.${setIndex}.reps`}
                        value={set.reps || ""}
                        onChange={handleChange}
                        size="sm"
                        placeholder="12"
                    />
                </div>
                <div className="col-lg-2 col-md-2 col-4">
                    <label className="strength-label-sub fw-bold text-uppercase text-center d-block">Carga</label>
                    <NeoInput
                        type="text"
                        name={`${baseName}.${setIndex}.load`}
                        value={set.load || ""}
                        onChange={handleChange}
                        size="sm"
                        placeholder="kg / lbs"
                    />
                </div>
                <div className="col-lg-2 col-md-6 col-12">
                    <label className="strength-label-sub fw-bold text-uppercase">Descanso</label>
                    <NeoInput
                        type="text"
                        name={`${baseName}.${setIndex}.rest`}
                        value={set.rest || ""}
                        onChange={handleChange}
                        size="sm"
                        placeholder="60s"
                    />
                </div>
            </div>

            {/* Linha Avançada (Método, Grupo Muscular, Equipamento, Cadência) */}
            <div className="row g-2 mt-1">
                <div className="col-md-3 col-6">
                    <label className="strength-label-sub fw-bold text-uppercase">Método</label>
                    <NeoInput
                        type="select"
                        name={`${baseName}.${setIndex}.strengthMethod`}
                        value={set.strengthMethod || "straight"}
                        onChange={handleChange}
                        size="sm"
                    >
                        {STRENGTH_EXERCISE_METHODS.map(method => (
                            <option key={method.value} value={method.value}>{method.label}</option>
                        ))}
                    </NeoInput>
                </div>
                <div className="col-md-3 col-6">
                    <label className="strength-label-sub fw-bold text-uppercase">Músculo Alvo</label>
                    <NeoInput
                        type="select"
                        name={`${baseName}.${setIndex}.muscleGroup`}
                        value={set.muscleGroup || ""}
                        onChange={handleChange}
                        size="sm"
                    >
                        <option value="">Selecione...</option>
                        {MUSCLE_GROUPS.map(g => <option key={g} value={g}>{g}</option>)}
                    </NeoInput>
                </div>
                <div className="col-md-3 col-6">
                    <label className="strength-label-sub fw-bold text-uppercase">Equipamento</label>
                    <NeoInput
                        type="select"
                        name={`${baseName}.${setIndex}.equipment`}
                        value={set.equipment || ""}
                        onChange={handleChange}
                        size="sm"
                    >
                        <option value="">Selecione...</option>
                        {STRENGTH_EQUIPMENT.map(e => <option key={e} value={e}>{e}</option>)}
                    </NeoInput>
                </div>
                <div className="col-md-3 col-6">
                    <label className="strength-label-sub fw-bold text-uppercase">Cadência (Tempo)</label>
                    <NeoInput
                        type="text"
                        name={`${baseName}.${setIndex}.tempo`}
                        value={set.tempo || ""}
                        onChange={handleChange}
                        size="sm"
                        placeholder="Ex: 3-0-1-0"
                    />
                </div>
            </div>

            {/* Linha de Observações e Ações */}
            <div className="row g-2 mt-2 align-items-center">
                <div className={`col-md-${alternatives.length > 0 ? 6 : 9} col-12`}>
                    <NeoInput
                        type="text"
                        name={`${baseName}.${setIndex}.description`}
                        value={set.description || ""}
                        onChange={handleChange}
                        size="sm"
                        placeholder="Instruções de execução, observações ou metas..."
                    />
                </div>
                {alternatives.length > 0 && (
                    <div className="col-md-3 col-12">
                        <NeoInput
                            type="select"
                            size="sm"
                            value=""
                            onChange={(event) => {
                                if (!event.target.value) return;
                                onReplaceExercise?.(event.target.value);
                            }}
                            title="Trocar por alternativa"
                        >
                            <option value="">Trocar por alternativa...</option>
                            {alternatives.map(alternative => (
                                <option key={alternative.id} value={alternative.id}>
                                    {alternative.name}
                                </option>
                            ))}
                        </NeoInput>
                    </div>
                )}
                <div className="col-md-3 col-12 d-flex justify-content-end gap-2 mt-2 mt-md-0">
                    {onDuplicate && (
                        <NeoButton
                            type="button"
                            variant="soft-secondary"
                            size="sm"
                            square
                            icon="mdi-content-copy"
                            title="Duplicar exercício"
                            onClick={onDuplicate}
                        />
                    )}
                    {onSaveToLibrary && (
                        <NeoButton
                            type="button"
                            variant="soft-primary"
                            size="sm"
                            square
                            icon="mdi-content-save-outline"
                            title="Salvar exercício na sua biblioteca"
                            onClick={() => onSaveToLibrary(set)}
                        />
                    )}
                    <NeoButton
                        type="button"
                        variant="soft-danger"
                        size="sm"
                        square
                        icon="mdi-delete-outline"
                        title="Remover exercício"
                        onClick={onRemove}
                    />
                </div>
            </div>
        </div>
    );
};

export default StrengthExerciseRow;
